import React, { useState, useEffect } from "react";
import OrgChart from "@balkangraph/orgchart.js";
import {
  makeStyles,
  Dialog,
  DialogContent,
  Paper,
  Grid,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Select } from "antd";
import "./balkan.css";
import {
  updateDepartments,
  getAdminDepartments,
} from "../../../actions/admin-actions";
import { BackIcon } from "../../../shared-resources/SVGIcons";
import ActionMessages from "../../../common-components/ActionMessages";
import { getSpecificResourceHierarchy } from "../../../actions/resource-management-actions";

const MembersHierarchy = ({ nodesData, isSpecific }) => {
  const { Option } = Select;
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [chart, setChart] = useState(null);
  const [nodeObj, setNodeObj] = useState({
    code: "",
    status: null,
    name: "",
    description: null,
    resource: null,
  });
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [pId, setPId] = useState(null);
  const [nodeId, setNodeId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [btnText, setBtnText] = useState("Add");
  const [isEditing, setIsEditing] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [isRearranged, setIsRearranged] = useState(false);
  const [nodes, setNodes] = useState([]);
  const [rearrangedNodeData, setRearrangedNodeData] = useState({
    id: "",
    pid: "",
  });
  const [specificResourceHierarchy, setSpecificResourceHierarchy] = useState(
    []
  );
  const updateDepartmentsData = useSelector(
    (state) => state.adminReducer.updateDepartmentsData
  );
  const specificResourceHierarchyData = useSelector(
    (state) => state.resourceManagementReducer.specificResourceHierarchyData
  );
  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };
  const useStyles = makeStyles({
    addSection: {
      display: "flex",
    },
    paperTitle: {
      color: "#0070D2",
      fontSize: "16px",
      fontWeight: 600,
      padding: "4px 16px",
      boxShadow: "0px 3px 6px #00000029",
      borderRadius: "8px",
    },
    addDialog: {
      width: "350px",
      position: "relative",
    },
    fieldTitle: {
      fontWeight: 600,
      marginBottom: "4px",
      fontSize: "13px",
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      padding: "5px",
      height: "100%",
    },
    dropDown: {
      outline: "none",
      borderRadius: "5px",
      padding: "5px",
      border: "1px solid #ccc",
    },
    inputField: {
      outline: "none",
      padding: "10px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      fontSize: "14px",
      fontWeight: "500",
      letterSpacing: "0.5px",
      marginBottom: "10px",
    },
    buttonsContainer: {
      display: "flex",
      width: "80%",
      justifyContent: "space-around",
      alignItems: "center",
      margin: "10px 0",
    },
    btn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "10px 15px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      margin: "2px 0 2px 8px",
      cursor: "pointer",
    },
  });
  const classes = useStyles();

  const formatText = (text) => {
    if (text) {
      text = text.trim();
      let result = "";
      let arr = text.split(" ");
      arr.forEach(
        (word) =>
          word &&
          word.length > 0 &&
          (result += `${word[0].toUpperCase()}${word.slice(1)} `)
      );
      return result;
    }
  };

  // const resourcesFormatted = departmentsResources.map((resource) => ({
  //   label: formatText(resource.resourceName),
  //   value: resource.resourceName,
  // }));
  const onBackClick = () => {
    history.push("/projects/resource-management");
  };
  const resetValues = () => {
    setNodeObj({
      code: "",
      status: "",
      name: "",
      description: "",
      resource: null,
    });
    setPId(null);
    setModalOpen(false);
    setBtnText("Add");
    setIsEditing(false);
    setIsRemoving(false);
  };

  const addNewNode = () => {
    if (nodeObj.code && nodeObj.name) {
      const { code, status, name, description, resource } = nodeObj;
      const newNode = {
        department_id: null,
        department: name,
        parent_department_id: pId ? pId : null,
        is_active: true,
        department_code: code,
        status,
        short_description: description,
        resource_id: resource == "null" ? null : resource,
        row_order: 0,
      };
      dispatch(updateDepartments(newNode));
      setModalOpen(false);
    }
  };

  const onEdit = (id) => {
    setBtnText("Update");
    setNodeId(id);
    setIsEditing(true);
  };

  const updateNode = () => {
    if (nodeObj.code && nodeObj.name) {
      const node = nodesData.filter((obj) => obj.department_id == nodeId);
      node[0].department = nodeObj.name;
      node[0].status = nodeObj.status;
      node[0].department_code = nodeObj.code;
      node[0].short_description = nodeObj.description;
      node[0].resource_id =
        nodeObj.resource == "null" ? null : nodeObj.resource;
      node[0].row_order = 0;
      node[0].is_active = true;
      dispatch(updateDepartments(node[0]));
      setNodeId(null);
      setModalOpen(false);
    }
  };

  const onRemove = (id) => {
    setIsRemoving(true);
    setNodeId(id);
  };

  const removeNode = () => {
    const nodesArr = nodes.filter((obj) => obj.id == nodeId);
    const existingNodesArr = nodesData.filter(
      (obj) => obj.department_id == nodeId
    );
    nodesArr[0].is_active = false;
    nodesArr[0].is_updated = true;
    nodesArr[0] = { ...existingNodesArr[0], ...nodesArr[0] };
    dispatch(updateDepartments(nodesArr[0]));
    setNodeId(null);
    setModalOpen(false);
    setIsRemoving(false);
  };

  const onRearrangeNode = (id, pid) => {
    // debugger;
    // const node = nodesData.filter((obj) => obj.resourceId== id);
    // if (node && node.length > 0) {
    //   node[0].parent_department_id = pid;
    //   // dispatch(updateDepartments(node[0]));
    // }
    let draggedNodeIdx;
    let targetNodeIdx;
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].id == id) {
        draggedNodeIdx = i;
      } else if (nodes[i].id == pid) {
        targetNodeIdx = i;
      }
    }
    if (targetNodeIdx !== 0 && draggedNodeIdx !== 0) {
      let nodesCopy = [...nodes];
      nodesCopy[draggedNodeIdx] = nodes[targetNodeIdx];
      nodesCopy[targetNodeIdx] = nodes[draggedNodeIdx];
      setNodes(nodesCopy);
    }
  };
  useEffect(() => {
    if (rearrangedNodeData.id) {
      onRearrangeNode(rearrangedNodeData.id, rearrangedNodeData.pid);
      setIsRearranged(false);
    }
  }, [rearrangedNodeData]);
  useEffect(() => {
    if (updateDepartmentsData.status && updateDepartmentsData.status === 200) {
      setMsgType("success");
      setEmptyErrMsg(true);
      setMsgText("Departments updated successfully");
      dispatch(getAdminDepartments());
    } else if (
      updateDepartmentsData.status &&
      updateDepartmentsData.status === 400
    ) {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText(updateDepartmentsData.message);
      dispatch(getAdminDepartments());
    }
  }, [updateDepartmentsData]);

  useEffect(() => {
    if (
      specificResourceHierarchyData.status &&
      (specificResourceHierarchyData.status === 200 ||
        specificResourceHierarchyData.status === 400)
    ) {
      setSpecificResourceHierarchy(specificResourceHierarchyData.data);
    }
  }, [specificResourceHierarchyData]);

  useEffect(() => {
    if (location.pathname == "/resource-hierarchy") {
      dispatch(getSpecificResourceHierarchy());
    }
  }, []);
  useEffect(() => {
    if (
      location.pathname == "/resource-hierarchy" &&
      specificResourceHierarchyData &&
      specificResourceHierarchyData.data &&
      specificResourceHierarchyData.data.data
    ) {
      if (
        specificResourceHierarchyData &&
        specificResourceHierarchyData.data &&
        specificResourceHierarchyData.data.data
      ) {
        let resourceIdArr = [specificResourceHierarchyData.data.parentNodeId];
        let formattedResourceIdArr = [];
        while (resourceIdArr.length > 0 && resourceIdArr[0] !== null) {
          let childnodes = specificResourceHierarchyData.data.data.filter(
            (node) => node.managerId == resourceIdArr[resourceIdArr.length - 1]
          );
          const id = resourceIdArr.pop();
          resourceIdArr.push(...childnodes.map((child) => child.resourceId));
          formattedResourceIdArr.push(id);
        }
        const arr = [];
        specificResourceHierarchyData.data.data.forEach((obj, idx) => {
          if (formattedResourceIdArr.includes(obj.resourceId)) {
            const nodeobj = {
              // ...obj,
              id: obj.resourceId,
              pid: obj.managerId,
              department: obj.department,
              resourceName: obj.resourceName,
              roles: obj.role[0],
              idx,
            };
            if (!obj.managerId) delete nodeobj.pid;
            arr.push(nodeobj);
          }
        });
        const sortedNodes = arr.sort((a, b) => a.idx - b.idx);
        setNodes([...sortedNodes]);
      } else {
        setNodes([]);
      }
    } else {
      if (nodesData && nodesData.length > 0) {
        const arr = [];
        nodesData.forEach((obj, idx) => {
          let parentNode = nodesData.filter(
            (node) => node.resourceId == obj.managerId
          );
          const nodeobj = {
            // ...obj,
            id: obj.resourceId,
            pid: obj.managerId,
            department: obj.department,
            resourceName: obj.resourceName,
            roles: obj.role[0],
            idx,
          };
          if (!obj.managerId) delete nodeobj.pid;
          arr.push(nodeobj);
        });
        const sortedNodes = arr.sort((a, b) => a.idx - b.idx);
        setNodes([...sortedNodes]);
      } else {
        setNodes([]);
      }
    }
  }, [nodesData, specificResourceHierarchyData]);
  const drawBalkanChart = () => {
    OrgChart.templates.ana.field_0 =
      '<text class="field_0" data-width="230" data-text-overflow="multiline-2-ellipsis" style="font-size: 14px; font-weight:bolder"  fill="#ffffff" x="125" y="30" text-anchor="middle">{val}</text>';
    OrgChart.templates.ana.field_1 =
      '<text class="field_1" data-width="230" data-text-overflow="multiline-2-ellipsis" style="font-size: 12px; font-weight:600" fill="#ffffff" x="125" y="60" text-anchor="middle">{val}</text>';
    OrgChart.templates.ana.field_2 =
      '<text class="field_2" data-width="230" data-text-overflow="multiline-2-ellipsis" style="font-size: 12px; font-weight:600" fill="#ffffff" x="125" y="90" text-anchor="middle">{val}</text>';
    // OrgChart.templates.ana.field_3 =
    //   '<text class="field_1" data-width="230" data-text-overflow="multiline-4-ellipsis" style="font-size: 18px;" fill="#ffffff" x="125" y="110" text-anchor="middle">Desc: {val}</text>';
    // OrgChart.templates.ana.field_4 =
    //   '<text class="field_1" style="font-size: 18px;" fill="#ffffff" x="125" y="140" text-anchor="middle">Manager: {val}</text>';
    // OrgChart.templates.ana.field_5 =
    //   '<text class="field_1" style="font-size: 18px;" fill="#ffffff" x="125" y="170" text-anchor="middle">Sub Dept: {val}</text>';
    OrgChart.elements.myTextArea = function (
      data,
      editElement,
      minWidth,
      readOnly
    ) {
      var id = OrgChart.elements.generateId();
      var value = data[editElement.binding];
      if (value == undefined) value = "";
      if (readOnly && !value) {
        return {
          html: "",
        };
      }
      var rOnlyAttr = readOnly ? "readonly" : "";
      var rDisabledAttr = readOnly ? "disabled" : "";
      return {
        html: `<label for="${id}" style="color:#a39f9f;font-weight:600;">${editElement.label}</label>
                        <textarea ${rDisabledAttr} ${rOnlyAttr} id="${id}" name="${id}" style="width: 100%;height: 100px; resize: none; background:#fff; color:#a39f9f;font-weight:600; border:none" data-binding="${editElement.binding}">${value}</textarea>`,
        id: id,
        value: value,
      };
    };
    OrgChart.RES.IT_IS_LONELY_HERE_LINK = "No hierarchy available!";
    if (!chart) {
      const newChart = new OrgChart(document.getElementById("orgchart"), {
        nodes: nodes,
        enableSearch: false,
        scaleInitial: nodes.length <= 4 ? 0.9 : OrgChart.match.boundary,
        // scaleInitial: OrgChart.match.boundary,
        // enableDragDrop: true,
        nodeMouseClick: OrgChart.action.none,
        siblingSeparation: 10,
        partnerNodeSeparation: 10,
        partnerChildrenSplitSeparation: 50,
        collapse: {
          level: 2,
          allChildren: true,
        },
        nodeBinding: {
          // field_0: "code",
          // field_1: "status",
          // field_2: "name",
          // field_3: "description",
          // field_4: "resource",
          // field_5: "sub",
          field_0: "resourceName",
          field_1: "department",
          // field_2: "sub",
          field_2: "roles",
        },
        // nodeMenu: {
        //   edit: {
        //     text: "Edit",
        //     onClick: (e) => {
        //       resetValues();
        //       setModalOpen(true);
        //       setPId(e);
        //       onEdit(e);
        //     },
        //   },
        //   add: {
        //     text: "Add",
        //     onClick: (e) => {
        //       resetValues();
        //       setPId(e);
        //       setModalOpen(true);
        //     },
        //   },
        //   remove: {
        //     text: "Remove",
        //     onClick: (id) => {
        //       onRemove(id);
        //     },
        //   },
        // },
        editForm: {
          readOnly: true,
          buttons: {
            edit: null,
            share: null,
            pdf: null,
            remove: null,
          },
          elements: [
            [
              {
                type: "textbox",
                label: "Employee Name",
                binding: "resourceName",
              },
              { type: "textbox", label: "Department", binding: "department" },
              // { type: "textbox", label: "Sub Department", binding: "sub" },
            ],
            [
              {
                type: "myTextArea",
                label: "Roles",
                binding: "roles",
              },
            ],
            // [
            //   { type: "textbox", label: "Name", binding: "name" },
            //   { type: "textbox", label: "Manager", binding: "resource" },
            // ],
            // {
            //   type: "myTextArea",
            //   label: "Description",
            //   binding: "description",
            // },
          ],
        },
      });
      newChart.on("add", function (sender, node) {
        return false;
      });
      newChart.on("drop", function (sender, targetId, position) {
        setIsRearranged(true);
        setRearrangedNodeData({
          ...rearrangedNodeData,
          id: targetId,
          pid: position,
        });
        return false;
      });
      setChart(newChart);
    } else {
      chart.load(nodes);
    }
  };
  useEffect(() => {
    drawBalkanChart();
  }, [chart, nodes]);

  useEffect(() => {
    if (nodeId && isEditing) {
      const node = nodes.filter((obj) => obj.id == nodeId);
      const resources = nodesData.filter((obj) => obj.department_id == nodeId);
      const { code, status, name, description } = node[0];
      setNodeObj({
        ...nodeObj,
        code,
        status,
        name,
        description,
        resource: resources[0].resource_id ? resources[0].resource_id : null,
      });
      setIsEditing(false);
    } else {
      if (nodeId && isRemoving) {
        removeNode();
      }
    }
  }, [nodeId, isEditing, isRemoving]);

  useEffect(() => {
    const userRole = JSON.parse(localStorage.getItem("roles"));

    if (userRole && userRole.length > 0 && userRole[0] == "ADMIN") {
      if (location.pathname == "/resource-hierarchy")
        window.location.assign("/");
    }
  }, []);

  return (
    <div style={{ padding: "12px" }}>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogContent className={classes.addDialog}>
          <h3 style={{ marginBottom: "10px", textAlign: "center" }}>
            Add Department
          </h3>
          <div className={classes.formContainer}>
            <div className={classes.fieldTitle}>Name</div>
            <input
              className={classes.inputField}
              placeholder="Department Name"
              value={nodeObj.name}
              onChange={(e) => setNodeObj({ ...nodeObj, name: e.target.value })}
            />
            <div className={classes.fieldTitle}>Code</div>
            <input
              className={classes.inputField}
              placeholder="Department Code"
              value={nodeObj.code}
              onChange={(e) => setNodeObj({ ...nodeObj, code: e.target.value })}
            />
            <div className={classes.fieldTitle}>
              Status{" "}
              <span style={{ color: "#72706f", fontSize: "12px" }}>
                (Optional)
              </span>
            </div>
            <input
              className={classes.inputField}
              placeholder="Status"
              value={nodeObj.status}
              onChange={(e) =>
                setNodeObj({ ...nodeObj, status: e.target.value })
              }
            />
            <div className={classes.fieldTitle}>
              Description{" "}
              <span style={{ color: "#72706f", fontSize: "12px" }}>
                (Optional)
              </span>
            </div>
            <textarea
              className={classes.inputField}
              placeholder="Short Description"
              value={nodeObj.description}
              onChange={(e) =>
                setNodeObj({ ...nodeObj, description: e.target.value })
              }
            />
            <div className={classes.fieldTitle}>
              Manager{" "}
              <span style={{ color: "#72706f", fontSize: "12px" }}>
                (Optional)
              </span>
            </div>
            <select
              className={classes.dropDown}
              onChange={(e) =>
                setNodeObj({ ...nodeObj, resource: e.target.value })
              }
            >
              <option value="null" selected={!nodeObj.resource}>
                None
              </option>
              {/* {departmentsResources &&
                departmentsResources.length > 0 &&
                departmentsResources.map((resource) => (
                  <option
                    value={resource.resourceId}
                    selected={nodeObj.resource == resource.resourceId}
                  >
                    {formatText(resource.resourceName)}
                  </option>
                ))} */}
            </select>
            {/* <div className={classes.fieldTitle}>Role</div> */}

            {/* <Select
              showArrow
              showSearch
              options={resourcesFormatted}
              value={nodeObj.resource}
              onChange={(value) => setNodeObj({ ...nodeObj, resource: value })}
              placeholder="Select Resource"
              // disabled={loading}
              style={{ width: "100%", zIndex: 1000 }}
            ></Select> */}

            <div className={classes.buttonsContainer}>
              <button
                className={classes.btn}
                style={{
                  background: "#fff",
                  border: "1px solid #0176d3",
                  color: "#0176d3",
                }}
                onClick={() => resetValues()}
              >
                Cancel
              </button>
              <button
                className={classes.btn}
                onClick={
                  btnText == "Add" ? () => addNewNode() : () => updateNode()
                }
              >
                {btnText}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {location.pathname == "/resource-hierarchy" && (
        <Paper elevation={0} className={classes.paperTitle}>
          <Grid container spacing={0}>
            <Grid item lg={10} style={{ margin: "12px 0" }}>
              <span
                onClick={onBackClick}
                style={{
                  float: "left",
                  marginRight: "16px",
                  cursor: "pointer",
                }}
              >
                {BackIcon()}
              </span>
              My Hierarchy
            </Grid>
          </Grid>
        </Paper>
      )}
      <div
        id="orgchart"
        style={{ width: "100%", maxHeight: "490px", margin: "12px 0 0 0" }}
      ></div>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </div>
  );
};

export default MembersHierarchy;
